import React, { useEffect, useState } from "react";
import "../assets/Loan/LoanCloserRequest.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllLoans,
  deleteLoan,
} from "../redux/slices/loan/loanReportSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCsv,
  faFileExcel,
  faPrint,
  faSortUp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { toast } from "react-toastify";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

const LoanCloserRequest = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
      const { profile } = useSelector((state) => state.userProfile);
  const { loans, loading, error } = useSelector((state) => state.loanReport);

  const [closerDate, setCloserDate] = useState("");
      const [company, setCompany] = useState(null);
  const [closerRemark, setCloserRemark] = useState("");

  const [filters, setFilters] = useState({
    loanAccountNumber: "",
    customerName: "",
    customerId: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loanCloseDialog, setLoanCloseDialog] = useState({
    open: false,
    loanId: null,
  });

        useEffect(() => {
        dispatch(fetchUserProfile());
      }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllLoans());
  }, [dispatch]);

    useEffect(()=>{
        const fetchCompany = async () => {
        try {
          const res = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
          );
          const data = await res.json();
          if (res.ok && data) {
            if (data.logo)
              data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
            setCompany(data);
          }
        } catch (err) {
          console.error("Failed to fetch company details", err);
        }
      };
      fetchCompany();
    },[profile?.superAdminId])

  // 🔹 Input filter handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const handleChange = (e) => {
    const value = Number(e.target.value);
    setItemsPerPage(value);
    console.log("Items per page:", value); // optional: send to parent or API
  };
  // 🔹 Apply search filters
  const applyFilters = (loan) => {
    const { loanAccountNumber, customerName, customerId } = filters;
    const isLoanAccountMatch =
      !loanAccountNumber ||
      loan.loanAccountNumber
        ?.toLowerCase()
        .includes(loanAccountNumber.toLowerCase());
    const isCustomerNameMatch =
      !customerName ||
      loan.userName?.toLowerCase().includes(customerName.toLowerCase());
    const isCustomerIdMatch =
      !customerId ||
      loan.customerId?.toLowerCase().includes(customerId.toLowerCase());
    return isLoanAccountMatch && isCustomerNameMatch && isCustomerIdMatch;
  };

  const filteredLoans = Array.isArray(loans) ? loans.filter(applyFilters) : [];

  // 🔹 Pagination Logic
  const totalItems = filteredLoans.length;
  const totalPages =
    itemsPerPage === "all" ? 1 : Math.ceil(totalItems / itemsPerPage);
  const startIndex =
    itemsPerPage === "all" ? 0 : (currentPage - 1) * itemsPerPage;
  const endIndex =
    itemsPerPage === "all" ? totalItems : startIndex + itemsPerPage;
  const paginatedLoans = filteredLoans.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  // const handleCloser=async(e)=>{
  //   e.preventDefault();
  //   try{
  //     const res=await axios.post(`https://payyug.in/api/loan/close/`)
  //   }catch(error){
  //     console.log(error)
  //   }
  // }

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(
      e.target.value === "all" ? "all" : parseInt(e.target.value, 10),
    );
    setCurrentPage(1);
  };

  const openLoanCloseDialog = (loanId) => {
    setLoanCloseDialog({ open: true, loanId });
  };

  const closeLoanCloseDialog = () => {
    setLoanCloseDialog({ open: false, loanId: null });
    setCloserDate("");
    setCloserRemark("");
  };

  const handleLoanClose = async (e) => {
    e.preventDefault();

    if (!closerDate || !closerRemark) {
      toast.warn("Date and remark required");
      return;
    }

    try {
      const res = await axios.post(
        // `https://payyug.in/api/loan/close/${loanCloseDialog.loanId}`,
        `https://payyug.in/api/request/loan/${loanCloseDialog.loanId}`,
        {
          closureRemark: closerRemark,
          closureDate: closerDate,
        },
      );

      console.log(res);
      toast.success(res?.data?.message||"Loan closed successfully");
      dispatch(fetchAllLoans());
      closeLoanCloseDialog();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to close loan");
      // console.error(err);
    }
  };

  // 🔹 Export to Excel
  const exportExcel = () => {
    const data = paginatedLoans.map((loan) => ({
      "Account Number": loan.loanAccountNumber,
      "Customer Id": loan.customerId,
      "Customer Name": loan.userName,
      "Loan Amount": loan.loanAmount,
      "Loan Status": loan.status,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    
      // 🔹 Header styling
      const headerCells = Object.keys(data[0]);
      headerCells.forEach((_, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef].s = {
          font: {
            bold: true,
            color: { rgb: "FFFFFF" },
          },
          fill: {
            fgColor: { rgb: "1F4E78" }, // dark blue
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      });
    
      // 🔹 Auto column width
      worksheet["!cols"] = headerCells.map((key) => ({
        wch: Math.max(key.length + 5, 18),
      }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loans");
    XLSX.writeFile(workbook, "LoanCloserRequestReport.xlsx");
  };

  // 🔹 Export to CSV
  const exportCSV = () => {
    const data = paginatedLoans.map((loan) => ({
      "Account Number": loan.loanAccountNumber,
      "Customer Id": loan.customerId,
      "Customer Name": loan.userName,
      "Loan Amount": loan.loanAmount,
      "Loan Status": loan.status,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "LoanCloserRequestReport.csv");
  };

  // 🔹 Export to PDF
  const exportPDF = async() => {
         const doc = new jsPDF("p", "mm", "a4");
          const pageWidth = doc.internal.pageSize.width;
          const pageHeight = doc.internal.pageSize.height;
    
            // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;
    
    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    
    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;
    
    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;
    
    // Draw circle
    doc.circle(centerX, centerY, radius);
    
    
    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(reader.result, "PNG", logoX, logoY, logoSize, logoSize);
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }
    
      // ================= COMPANY NAME (AUTO WRAP) =================
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
    
      const nameX = logoX + logoSize + 5;
      const nameY = 18;
      const nameMaxWidth = pageWidth - nameX - 15;
    
      const companyNameText = doc.splitTextToSize(
        (company?.name || "COMPANY NAME").toUpperCase(),
        nameMaxWidth
      );
    
      doc.text(companyNameText, nameX, nameY);
    
      // Calculate Y after company name
      let currentY = nameY + companyNameText.length * 6;
    
      // ================= COMPANY DETAILS =================
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    
      const detailX = nameX;
      const detailMaxWidth = nameMaxWidth;
    
      // Address
      const addressText = doc.splitTextToSize(
        company?.address || "Company Address",
        detailMaxWidth
      );
      doc.text(addressText, detailX, currentY);
      currentY += addressText.length * 5;
    
      // Email
      const emailText = doc.splitTextToSize(
        `Email: ${company?.email || "-"}`,
        detailMaxWidth
      );
      doc.text(emailText, detailX, currentY);
      currentY += emailText.length * 5;
    
      // Phone
      const phoneText = doc.splitTextToSize(
        `Phone: ${company?.contact || "-"}`,
        detailMaxWidth
      );
      doc.text(phoneText, detailX, currentY);
      currentY += phoneText.length * 5;
    
      // Divider
      doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);
    
      // ================= REPORT TITLE =================
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text(
        "Loan Closer Request Report",
        pageWidth / 2,
        currentY + 14,
        { align: "center" }
      );
    
    const tableColumn = [
      "SN",
      "Loan Account",
      "Customer Id",
      "Customer Name",
      "Loan Amount",
      "Loan Status",
    ];
    const tableRows = [];

    paginatedLoans.forEach((loan, index) => {
      const loanData = [
        index + 1,
        loan.loanAccountNumber,
        loan.customerId,
        loan.userName,
        loan.loanAmount,
        loan.status,
      ];
      tableRows.push(loanData);
    });

autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY:currentY+ 20,
       theme: "grid",
  styles: {
    fontSize: 7,
    cellPadding: 3,
    halign: "center",
  },
  headStyles: {
    fontStyle: "bold",
    fontSize: 7,
  },
  footStyles: {
    fillColor: [220, 220, 220],
    textColor: 20,
    fontStyle: "bold",
    fontSize: 8,
  },
  alternateRowStyles: {
    fillColor: [245, 245, 245],
  },
    });
    doc.save("LoanCloserRequestReport.pdf");
  };

  return (
    <div className="loanCloserRequest-container">
      {/* 🔹 Filter Section */}
      <section className="loanCloserRequest-filter">
        <h2 className="loanCloserRequest-filter-title">
          Loan Closer Request Filter
        </h2>

        <form
          className="loanCloserRequest-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="loanCloserRequest-form-group">
            <label>Loan Account Number</label>
            <input
              name="loanAccountNumber"
              value={filters.loanAccountNumber}
              placeholder="Loan Account Number"
              onChange={handleInputChange}
            />
          </div>

          <div className="loanCloserRequest-form-group">
            <label>Customer Name</label>
            <input
              name="customerName"
              value={filters.customerName}
              placeholder="Customer Name"
              onChange={handleInputChange}
            />
          </div>

          <div className="loanCloserRequest-form-group">
            <label>Customer Id</label>
            <input
              name="customerId"
              value={filters.customerId}
              placeholder="Customer Id"
              onChange={handleInputChange}
            />
          </div>
        </form>
      </section>

      {/* 🔹 Loan Details */}
      <section className="loanCloserRequest-details">
        {/* Export Buttons */}
        <div className="loanCloserRequest-header">
          <div className="loanCloserRequest-header-left">
            <h2 className="loanCloserRequest-details-title">Loan Details</h2>

            <div className="loanCloserRequest-items-per-page">
              <label htmlFor="itemsPerPage">Items per page:</label>
              <select
                id="itemsPerPage"
                value={itemsPerPage}
                onChange={handleChange}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={50000}>All</option>
              </select>
            </div>
          </div>

          <div className="loanCloserRequest-header-actions">
            <button className="loanCloserRequest-btn-csv" onClick={exportCSV}>
              <FontAwesomeIcon icon={faFileCsv} /> CSV
            </button>
            <button
              className="loanCloserRequest-btn-excel"
              onClick={exportExcel}
            >
              <FontAwesomeIcon icon={faFileExcel} /> Excel
            </button>
            <button className="loanCloserRequest-btn-print" onClick={exportPDF}>
              <FontAwesomeIcon icon={faPrint} /> PDF
            </button>
          </div>
        </div>

        {/* Items per page selector */}

        {/* Loan Table */}
        <div className="loanCloserRequest-table-wrapper">
          <table className="loanCloserRequest-table">
            <thead>
              <tr>
                <th>
                  SN. <FontAwesomeIcon icon={faSortUp} />
                </th>
                <th>Account Number</th>
                <th>Customer Id</th>
                <th>Customer Name</th>
                <th>Loan Amount</th>
                <th>Loan Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="7" style={{ color: "red" }}>
                    {error}
                  </td>
                </tr>
              ) : paginatedLoans.length > 0 ? (
                paginatedLoans.map((loan, index) => {
                  const loanStatus = loan.status?.toLowerCase();
                  return (
                    <tr
                      className={
                        loanStatus.toLowerCase() === "closed"
                          ? "closed-row"
                          : loanStatus.toLowerCase() === "requested"
                            ? "requested-row"
                            : ""
                      }
                      key={loan.id || index}
                    >
                      <td>{startIndex + index + 1}</td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.customerId || "N/A"}</td>
                      <td>{loan.userName || "N/A"}</td>
                      <td>
                        ₹{Number(loan.loanAmount || 0).toLocaleString("en-IN")}
                      </td>
                      <td className={`Status-${loanStatus.toLowerCase()}`}>
                        {loan.status || "N/A"}
                      </td>
                      <td>
                        {loanStatus.toLowerCase() === "closed" ||
                        loanStatus.toLowerCase() === "requested" ? (
                          <button
                            className={`loanCloserRequest-btn-disabled ${
                              loanStatus.toLowerCase() === "closed"
                                ? "closed-btn"
                                : "requested-btn"
                            }`}
                            disabled
                            aria-disabled="true"
                            title={
                              loanStatus.toLowerCase() === "closed"
                                ? "Loan already closed"
                                : "Loan close requested"
                            }
                          >
                            {loanStatus}
                          </button>
                        ) : (
                          <button
                            className="loanCloserRequest-btn-view-emi"
                            onClick={() => openLoanCloseDialog(loan.id)}
                          >
                            Close
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7">No loan records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {itemsPerPage !== "all" && (
          <div className="loanCloserRequest-pagination">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="prevbtn"
            >
              Prev
            </button>
            <span>
              {" "}
              Page {currentPage} of {totalPages}{" "}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </section>

      {/* Loan Close Confirmation Dialog */}
      {loanCloseDialog.open && (
        <div className="loan-closer-dialog-overlay">
          <div className="loan-closer-dialog">
            <h3>Loan Close Confirmation</h3>

            <form onSubmit={handleLoanClose}>
              <input
                type="date"
                value={closerDate}
                onChange={(e) => setCloserDate(e.target.value)}
              />
              <input
                type="text"
                placeholder="Remark"
                value={closerRemark}
                onChange={(e) => setCloserRemark(e.target.value)}
              />

              <div className="dialog-buttons">
                <button type="submit" className="btn-confirm">
                  Close
                </button>
                <button
                  type="button"
                  onClick={closeLoanCloseDialog}
                  className="btn-cancel"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoanCloserRequest;
